import { render, staticRenderFns } from "./KnowledgeDetailDialog.vue?vue&type=template&id=84e77560&scoped=true"
import script from "./KnowledgeDetailDialog.vue?vue&type=script&lang=js"
export * from "./KnowledgeDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeDetailDialog.vue?vue&type=style&index=0&id=84e77560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e77560",
  null
  
)

export default component.exports